import { render, staticRenderFns } from "./VoteDefaultLayout.vue?vue&type=template&id=d5e7d880&scoped=true"
import script from "./VoteDefaultLayout.vue?vue&type=script&lang=js"
export * from "./VoteDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e7d880",
  null
  
)

export default component.exports